import { ChangeEvent, forwardRef, useState } from 'react';
import { Input } from '@components/input';
import { LabelPrimary } from '@components/label';

import { InputVatNumberProps } from './input-vat-number.type';

export const InputVatNumber = forwardRef<HTMLInputElement, InputVatNumberProps>(
  ({ hasError, onChange, value = '', country, id, name, countryLabel, vatLabel, helperText, error, ...props }, ref) => {
    const [internalValue, setInternalValue] = useState<string | undefined>(value);

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      setInternalValue(e.target.value);
      onChange?.(e);
    };

    return (
      <div className='flex gap-2'>
        <div className='w-[121px]'>
          <LabelPrimary htmlFor='country-vat-number'>{countryLabel}</LabelPrimary>
          <Input id='country-vat-number' value={country} disabled readOnly />
        </div>

        <div className='w-full'>
          <LabelPrimary htmlFor='vat-number'>{vatLabel}</LabelPrimary>
          <Input
            ref={ref}
            id={id}
            name={name}
            value={internalValue}
            onChange={handleChange}
            hasError={hasError}
            {...props}
          />
          {helperText && <p className='mt-1 text-xs text-secondary'>{helperText}</p>}
          {error && <p className='mt-1 text-xs text-critical-no-bg'>{error}</p>}
        </div>
      </div>
    );
  }
);
